import { useFieldsStyles } from 'assets/styles/common';
import { ShowRecordButton } from 'components';
import { FC } from 'react';
import { Datagrid, DateField, List, ListProps, NumberField, TextField, TextInput } from 'react-admin';
import { ResourceName } from 'types/resources';

const SearchInput = <TextInput key="filter" source={`${ResourceName.ANALYSIS_KINDS}.filter`} label="Search" alwaysOn />;

export const AnalysisKindsList: FC<ListProps> = (props) => {
  const { textField } = useFieldsStyles();
  return (
    <List {...props} filters={[SearchInput]} bulkActionButtons={false}>
      <Datagrid>
        <NumberField source="id" sortable={false} />
        <DateField source="createdAt" sortable={false} />
        <DateField source="updatedAt" sortable={false} />
        <TextField source="name" className={textField} sortable={false} />
        <TextField source="label" className={textField} sortable={false} />
        <ShowRecordButton />
      </Datagrid>
    </List>
  );
};
